import { memo } from 'react';
import { tokens } from '@optiaxiom/globals';
import { BaseEdge, EdgeProps, getSmoothStepPath, useInternalNode } from '@xyflow/react';

import { getEdgeParams } from './utils';

export const CustomEdge = memo(
  ({ id, source, target, style = {}, markerEnd, selected }: EdgeProps) => {
    const sourceNode = useInternalNode(source);
    const targetNode = useInternalNode(target);

    if (!sourceNode || !targetNode) {
      return null;
    }

    const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition } = getEdgeParams(
      sourceNode,
      targetNode
    );

    const [edgePath] = getSmoothStepPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });

    return (
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          strokeWidth: selected ? 3 : 2,
          stroke: selected
            ? tokens.colors['border.accent']
            : style.stroke || tokens.colors['fg.avatar.purple'],
        }}
      />
    );
  }
);

CustomEdge.displayName = 'CustomEdge';
